import {Box, CircularProgress} from '@mui/material'
import {GetConsultPdfResponse} from '../../redux/consult'
import ConsultPdf from '../../components/ConsultPdf'

interface Props {
  landingId: string
  pdf: GetConsultPdfResponse | null | undefined
}

const View = ({landingId, pdf}: Props) => {
  if (pdf === null) {
    return (
      <Box
        height="100vh"
        width="100vw"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <CircularProgress />
      </Box>
    )
  }

  if (pdf === undefined) {
    return null
  }

  return <ConsultPdf landingId={landingId} pdf={pdf} />
}

export default View
